/* ==========================================================================
   product-card-atc.js
   Tomato Superstar — product-card "Add to Cart"

   Markup: snippets/product-card-atc.liquid
   Styles: assets/custom-audit-changes.css → TASK 21

   The card button now adds straight to the cart through the theme's own hook
   (.js-grid-cart → theme.addCartButton, assets/theme.js ~3679). It used to
   forward multi-variant cards to the Quickshop dialog instead; that branch is
   gone, so no click is forwarded anywhere any more.

   What is left here is one guard. The theme's handler marks the button
   .is-loading and clears it a second later, but never blocks the button in the
   meantime, so a shopper who clicks twice fires Shopify.addItem twice and ends
   up with two of the item. That was easy to miss while multi-variant cards
   opened a dialog; now that every available card adds directly, it is not.

   The listener is on `document` in the CAPTURE phase so it runs before the
   theme's jQuery handler, which is delegated on `document` in the bubble
   phase. Stopping propagation here therefore stops that handler too.

   THEME EDITOR SAFETY. One delegated listener bound to `document` once, when
   this file executes. Section re-renders in the Customizer replace card markup
   but never re-run this script, so it cannot double-bind, and because the
   listener is on `document` rather than on the cards it keeps working on
   markup that did not exist when it ran. Nothing to destroy on
   shopify:section:unload, so no listener can leak.

   No cart code lives in this file: nothing is added to the cart here, no cart
   state is read or written, and no global is created.
   ========================================================================== */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var btn = target.closest('.tss-atc.js-grid-cart');
    if (!btn) return;

    /* An add is already in flight for this card — swallow the click entirely
       rather than letting the theme queue a second Shopify.addItem. */
    if (btn.classList.contains('is-loading') || btn.disabled) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
}());
